import isProd from 'www/utils/is/isProd'
import createDevLog from 'www/utils/withDependences/createDevLog'

function sendGoogleGoal(eventName: string, opts: object = {}) {
  if (!isProd) {
    createDevLog({
      module: 'GoogleGoals',
      title: 'Цель:',
      message: eventName,
    })

    return
  }

  if (
    typeof window.gtag === 'function'
    && eventName
    && window.IS_YDOC
  ) {
    window.gtag('event', eventName, opts)
  }
}

export default sendGoogleGoal
